/**
 * Calculates a horizontal offset to prevent a dropdown from overflowing the right edge of the viewport.
 * @param {DOMRect|null} rect - Bounding rect of the trigger element.
 * @param {number} dropdownWidth - Width of the dropdown in pixels.
 * @param {number} [padding=16] - Minimum padding from the viewport edge.
 * @param {number} [innerWidth=window.innerWidth] - Viewport width; injectable so callers can stay pure.
 * @returns {number} Negative offset to shift the dropdown left, or 0 if no adjustment needed.
 */
export const getLeftOffset = (
  rect,
  dropdownWidth,
  padding = 16,
  innerWidth = window.innerWidth
) => {
  if (!rect) return 0;
  const overflow = rect.left + dropdownWidth - innerWidth + padding;
  return overflow > 0 ? -overflow : 0;
};
